import gql from 'graphql-tag';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Validate from './Validate';
import Hideable from './Hideable';
import SignInThirdParty from './SignInThirdParty';
import { Alert, Box, Button, Container, Divider, Stack, TextField, Typography } from '@mui/material';

const REGISTER = gql`
mutation Register($name:String, $email:String!, $password:String!) {
  register(input: {name:$name, email:$email}, password: $password) {
    created
  }
}`
;

const Register = props => {
  const [values, setValues] = useState({name: '', email: '', password: ''});
  const [error, setError] = useState(null);
  let navigate = useNavigate();

  const handleChange = e => {
    const {name, value} = e.target
    setValues({...values, [name]: value})
  }

  document.title = `navscout - Register`;

  return (
    <Box sx={{ padding: { xs: 3, sm: 5 } }}>
      <Box mb={4}>
        <Typography variant="h4" component="h1" gutterBottom>
          Let's get started.
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Get started with navscout! Create a free account to unlock real-time weather and route scanning. Just enter your email and a password. Add your name, and we'll be able to personalize your updates.
        </Typography>
      </Box>

      <Box sx={{ mb: 4 }}>
        <SignInThirdParty account={props.account} client={props.client} />
      </Box>

      <Divider sx={{ my: 4 }}>
        <Typography variant="body2" color="text.secondary">
          OR
        </Typography>
      </Divider>

      <Hideable hidden={error === null}>
        <Alert severity='error' sx={{ mb: 3 }}>
          Unable to register with the provided account details.
        </Alert>
      </Hideable>

      <form
        onSubmit={e => {
          e.preventDefault();
          register(props.client, values, navigate, setError);
        }}
      >
        <Stack spacing={2.5}>
          <TextField
            fullWidth
            name='email'
            placeholder='Email'
            label='Email'
            value={values.email}
            onChange={handleChange}
          />
          <TextField
            fullWidth
            type='password'
            name='password'
            placeholder='Password'
            label='Password'
            value={values.password}
            onChange={handleChange}
          />
          <TextField
            fullWidth
            name='name'
            placeholder='Name (Optional)'
            label='Name (Optional)'
            value={values.name}
            onChange={handleChange}
          />
          <Button
            fullWidth
            variant='contained'
            type="submit"
            disabled={!Validate.notBlank(values.email, values.password)}
          >
            Register
          </Button>
        </Stack>
      </form>
    </Box>
  );
}

const register = (client, values, navigate, setError) => {
  console.log('register ', values);
  client.mutate({
    mutation: REGISTER,
    variables: values,
    refetchQueries: ['Account']
  }).then(data => {
    if (data.data.register === null) {
      console.log('Registration failed');
    } else {
      window.location.reload()
    }
  }).catch(e => {
    console.error("Unable to register", e)
    setError(e)
  });
}

export default Register;